module.exports = __webpack_public_path__ + "static/img/img__payment-success.050be53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img__payment-success.png
// module id = z6Cf
// module chunks = 1